import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { body2, spacing, duration, easing, colors } from 'ui/theme';
import { fontSizes } from 'ui/theme/typography';
import { Link } from 'react-router-dom';

interface SegmentWrapperProps {
  isRoot?: boolean;
}

export const FolderNameLink = styled(Link)`
  color: ${colors.cyan50};
  transition: color ${duration.short} ${easing.entrance};
  font-weight: 500;
  text-decoration: underline;
  text-decoration-thickness: ${pxToRem(1.5)};
  text-decoration-color: transparent;
  text-underline-offset: 2px;
  transition-property: color, text-decoration-color;
  transition-duration: ${duration.short};
  transition-timing-function: ${easing.entrance};
  cursor: pointer;
  outline-offset: ${spacing.eighth};

  &:hover {
    color: ${colors.cyan100};
    text-decoration-color: ${colors.cyan100};
  }
`;

export const SegmentWrapper = styled.div<SegmentWrapperProps>`
  align-items: center;
  display: flex;
  justify-content: flex-start;
  overflow: hidden;

  > * {
    flex: 0 0 auto;
    margin-left: ${spacing.half};
  }

  /** the root items don't get left padding on the icon */
  > *:first-child {
    margin-left: ${({ isRoot }) => (isRoot ? '0px' : spacing.half)};
  }
`;

interface LabelProps {
  isLastItem?: boolean;
  isMini?: boolean;
  ref?: any;
}
export const Label = styled.div<LabelProps>`
  ${body2}
  flex: 1 1 auto;
  max-width: ${({ isLastItem }) => (isLastItem ? 'none' : '140px')};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;

  ${({ isMini }) => (isMini ? `font-size: ${fontSizes.s12}; line-height: ${fontSizes.s16};` : '')}
`;
